//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DropzoneSection from "@Shared/components/sections/dropzone-section";
import UploadFilesModal from "@Broker/@Modules/util-components/upload-files-modal/upload-files-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UploadDocuments",
  components: {
    DropzoneSection,
    UploadFilesModal
  },
  props: {
    applicationId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    uploading: {
      type: Boolean,
      default: false
    },
    uploadingSucceeded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedClassification: {},
      selectedFiles: []
    };
  },
  methods: {
    handleClassificationSelection(classification) {
      this.selectedClassification = classification || {};
    },
    handleAddDocument(files) {
      this.selectedFiles = files;
      this.$refs.organize.openModal();
    },
    handleUploadDocuments() {
      this.$emit("upload-documents", {
        files: this.selectedFiles,
        classification: {
          documentRequestId: this.selectedClassification.documentRequestId || this.selectedClassification.id,
          classification: this.selectedClassification.documentType,
          description: ""
        }
      });
    },
    resetData() {
      this.$refs.dropzoneSection.removeAllFiles();
      this.selectedFiles = [{
        name: ""
      }];
      this.selectedClassification = {};
    },
    handleRemovedAllFiles() {
      this.$refs.organize.closeModal();
    }
  }
});